import React from 'react';
import Spinner from 'react-spinner';

import {
  assistanceTopics,
  defaultAssistanceColor,
} from '../../resources/thematic-topics';
import AssistanceText from '../AssistanceLanding/AssistanceLandingText';
import CountryAssistanceSeekingPOA from './CountryAssistanceSeekingPOA';
import CountryAssistanceOECD from './CountryAssistanceOECD';

export default class AssistanceCountryPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      assistanceNeeds: null,
      poaLoading: false,
      oecdLoading: false
    };
  }

  handleLoading(type) {
    return (isLoading) => {
      const newState = {};
      newState[type] = isLoading;
      this.setState(newState);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const wasLoading = prevState.poaLoading || prevState.oecdLoading,
      isLoading = this.state.poaLoading || this.state.oecdLoading;

    if (wasLoading && !isLoading && this.props.anchorTo) {
      document.querySelector(this.props.anchorTo).scrollIntoView();
    }
  }

  renderContent() {
    const { countryName, countryCode } = this.props,
      isLoading = this.state.poaLoading || this.state.oecdLoading;

    return (
      <div>
        <CountryAssistanceSeekingPOA
          countryName={countryName}
          countryCode={countryCode}
          thematicDict={assistanceTopics}
          defaultColor={defaultAssistanceColor}
          onLoading={ this.handleLoading('poaLoading') }
          hide={ isLoading }
        />
        <CountryAssistanceOECD
          countryCode={ countryCode }
          onLoading={ this.handleLoading('oecdLoading') }
          hide={ isLoading }
        />
      </div>
    );
  }

  renderSpinner() {
    const isLoading = this.state.poaLoading || this.state.oecdLoading;
    if (!isLoading) return null;

    return (
      <div className="assistance-page-panel__spinner">
        <Spinner />
      </div>
    );
  }

  render() {
    const countryName = this.props.countryName;

    return (
      <div>
        <h2 className="inline-heading">
          <small>Assistance</small>
          <br />International Assistance: <strong>{countryName}</strong>
        </h2>
        <AssistanceText />
        { this.renderSpinner() }
        { this.renderContent() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CountryAssistance/CountryAssistance.js